module.exports = __webpack_public_path__ + "static/img/ERA.27a04057.jpg";